import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Fade out & remove the static HTML loader after page load
window.addEventListener("load", () => {
  const preloader = document.getElementById("preloader");
  if (preloader) {
    preloader.style.opacity = "0";
    preloader.style.transition = "opacity 0.3s ease";
    setTimeout(() => preloader.remove(), 300);
  }
});

/**
 * When the PWA is installed (via button or browser menu),
 * remember what page was installed:
 *  - "/" -> "__HOME__"
 *  - "/myshop" -> "myshop"
 *  - "/myshop/manager" -> "myshop"
 *  - "/admin" should not become the installed target
 */
window.addEventListener("appinstalled", () => {
  try {
    const path = window.location.pathname; // example: "/", "/slug", "/slug/manager", "/admin", "/pwa-start"
    let target = "__HOME__";

    if (path && path !== "/" && path !== "/pwa-start") {
      const parts = path.split("/").filter(Boolean); // example: ["slug", "manager"]
      const first = parts[0] || "";

      // Avoid saving non-public routes as the target
      const blocked = new Set(["admin", "login", "pwa-start", "privacy-policy"]);
      if (first && !blocked.has(first)) {
        target = first; // this is your ":slug"
      }
    }

    localStorage.setItem("smartbusinessInstalledSlug", target);
  } catch (e) {
    console.error("[PWA] appinstalled handler error:", e);
  }
});

// Register the service worker ASAP (not inside window.onload)
serviceWorkerRegistration.register();